<template>
    <div style="float:left">
        <span :class="spanClass"/>
        <ur-tooltip v-if="tooltipShow" bottom :manualClose="false" mover>
            <strong>{{questionTitle}}</strong>
            <p>{{questionContents}}</p>
            <span :class="spanClass">{{questionResult}}</span>
        </ur-tooltip>
    </div>
</template>
<script>
import urTooltip from '@uidev/components/element/urTooltip/urTooltip';
export default {
    name:'aicc-scenario-progress-cell',
    components:{
        urTooltip:urTooltip,
    },
    props: {
        answerType:{type: String, default:'',},
        questionTitle:{type: String, default:'',},
        questionContents:{type: String, default:'',},
    },
    data() {
        return {
        }
    },
    computed:{
        tooltipShow() {
            switch(this.answerType) {
                case 'A':
                case 'B':
                case 'C':
                    return true;
                default:
                    return false;
            }
        },
        spanClass(){
            switch(this.answerType) {
                case 'A':
                    return 'p2';
                case 'B':
                    return 'p3';
                case 'C':
                    return 'p1';
                default:
                    return '';
            }
        },
        questionResult(){
            switch(this.answerType) {
                case 'A':
                    return '질문의도 충족';
                case 'B':
                    return '질문의도 미충족';
                case 'C':
                    return '반복 후 의도충족';
                case 'E':
                    return '미응답';
                default:
                    return '';
            }
        }
    },
    methods:{},
}
</script>
<style scoped>
    .progress_bar span {
        display: inline-block;
        flex-shrink: 0;
        margin: 0 4px 0 0;
        border-radius: 2px;
        background-color: #bebebe;
        height: 8px;
        width: 28px;
    }
    .progress_bar span.p1 {
        background-color: #b4d6a2;
    }
    .progress_bar span.p2 {
        background-color: #0ebb59;
    }
    .progress_bar span.p3 {
        background-color: #ff5858;
    }
    .ur-tooltip {
        background-color:rgba(0,0,0,0.8);
    }
    .ur-tooltip strong {
        display: block;
        font-size: 14px;
        font-weight: bold;
        color: #fff;
    }
    .ur-tooltip span.p1 {
        color: #b4d6a2;
    }
    .ur-tooltip span.p2 {
        color: #0ebb59;
    }
    .ur-tooltip span.p3 {
        color: #ff5858;
    }
</style>